import styled from 'styled-components'

export const SearchBar = styled.div`
  width: 300px;
  margin-right: 15px;
`
